function Privacy() {
  return (
    <div className="min-h-screen bg-secondary-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-secondary-900 mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-secondary-600 mb-6">
            Última actualización: 15 de febrero de 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">1. Información que Recolectamos</h2>
            <p className="text-secondary-600">
              Esta aplicación no recolecta ni almacena ninguna información personal identificable. 
              Los datos de los participantes y resultados son almacenados localmente en su navegador 
              y no son transmitidos a ningún servidor.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">2. Uso de Datos Locales</h2>
            <p className="text-secondary-600">
              Los nombres de los participantes y el historial de selecciones se almacenan en el 
              almacenamiento local de su navegador (localStorage) y son utilizados únicamente para 
              el funcionamiento de la aplicación.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">3. Cookies</h2>
            <p className="text-secondary-600">
              Esta aplicación no utiliza cookies ni tecnologías de seguimiento.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">4. Contacto</h2>
            <p className="text-secondary-600">
              Si tiene alguna pregunta sobre esta política de privacidad, puede contactarnos en:
              <br />
              <a 
                href="mailto:info@reynergonzalez.com" 
                className="text-primary-600 hover:text-primary-700"
              >
                info@reynergonzalez.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy; 